import { CALL, EMAIL, LINKED_IN, LOGGED_CALL, LOGGED_EMAIL, LOGGED_LINKED_IN_MESSAGE, LOGGED_MEETING, LOGGED_POSTAL_MAIL, LOGGED_SMS, LOGGED_WHATS_APP, NOTE, SCHEDULE, TASK, ENROLLED_IN_SEQUENCE, WHATS_APP } from 'crm-activity-creator-data/interaction/InteractionTypes';
import CreateCallButton from '../buttons/call/CreateCallButton';
import CreateNoteButton from '../buttons/CreateNoteButton';
import CreateEmailButton from '../buttons/CreateEmailButton';
import CreateTaskButton from '../buttons/CreateTaskButton';
import CreateMeetingButton from '../buttons/CreateMeetingButton';
import CreateLinkedInButton from '../buttons/CreateLinkedInButton';
import CreateLogCallButton from '../buttons/CreateLogCallButton';
import CreateLogEmailButton from '../buttons/CreateLogEmailButton';
import CreateLogMeetingButton from '../buttons/CreateLogMeetingButton';
import CreateEnrollInSequenceButton from '../buttons/sequence/CreateEnrollInSequenceButton';
import CreateLogWhatsAppButton from '../buttons/CreateLogWhatsAppButton';
import CreateLogSMSButton from '../buttons/CreateLogSMSButton';
import CreateLogLinkedInButton from '../buttons/CreateLogLinkedInButton';
import CreateLogPostalMailButton from '../buttons/CreateLogPostalMailButton';
import CreateWhatsAppButton from '../buttons/whatsApp/CreateWhatsAppButton';
export const BUTTON_COMPONENTS = {
  [NOTE]: CreateNoteButton,
  [TASK]: CreateTaskButton,
  [EMAIL]: CreateEmailButton,
  [SCHEDULE]: CreateMeetingButton,
  [CALL]: CreateCallButton,
  [LINKED_IN]: CreateLinkedInButton,
  [LOGGED_CALL]: CreateLogCallButton,
  [LOGGED_EMAIL]: CreateLogEmailButton,
  [LOGGED_LINKED_IN_MESSAGE]: CreateLogLinkedInButton,
  [LOGGED_MEETING]: CreateLogMeetingButton,
  [LOGGED_POSTAL_MAIL]: CreateLogPostalMailButton,
  [LOGGED_SMS]: CreateLogSMSButton,
  [LOGGED_WHATS_APP]: CreateLogWhatsAppButton,
  [ENROLLED_IN_SEQUENCE]: CreateEnrollInSequenceButton,
  [WHATS_APP]: CreateWhatsAppButton
};